import Dashboard from "../../../component/Pmc/Dashboard/Dashboard"
import { CustomLinkButLink } from "../../../style/Button";

const PmsDashboard = () => {
  return (
    <>
      <div style={{ width: "100%" }}>
        <div style={{ paddingBottom: "100px" }}>
          <Dashboard />
          <div style={{ marginTop: 0 }} className="text-right">
            <CustomLinkButLink
              className=""
              primary
              style={{ marginBottom: "15px" }}
              to="/Pmc/pendingrx"
            >
              Next
            </CustomLinkButLink>
          </div>
        </div>
      </div>
    </>
  )
}

export default PmsDashboard
